export function Back({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <path d="M2.33325 14H25.6666M9.37992 7L2.33325 14L9.37992 21" stroke="black" stroke-width="1.75" stroke-linecap="square"/>
</svg>

  );
}
